import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        debug: true,
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: {
                translation: {
                    general: {
                        yes: 'Yes',
                        no: 'No'
                    },
                    main: {
                        partnerAccess: 'Partner Access'
                    },
                    error: {
                        message1: 'Looks like we have some problem. Please try again in a few seconds.',
                        message2: 'If it still doesn\'t work, write to us at',
                        message3: 'and we will fix it as soon as possible.'
                    },
                    partner: {
                        onlyExcelAllowed: 'Only Excel files in .xlsx format is allowed',
                        eventFinishedError: 'Hello, it seems that the event has ended. If this is not the case, please write to support@proxyhands.com, and we will assist you.',
                        genericError: 'Hello, we are experiencing some technical difficulties. Please try again in a few seconds. If it still doesn\'t work, write to us at support@proxyhands.com, explaining the issue.',
                        excelDateParserError: 'Dates are mandatory and must follow the format yyyy/MM/dd (for example, 2021/5/24). Use / as the separator. The year must have 4 digits.',
                        excelTimeParserError: 'The time is mandatory and must follow the format HH:MM (for example, 21:30). They are separated by : and do not include seconds.',
                        excelLocationParserError: 'The location column is causing issues. Try entering the value without unusual symbols (just text and numbers). If it doesn\'t work, try uploading the Excel without that column, as it is optional.',
                        excelParserError1: 'The excel row ',
                        excelParserError2: ' has an incorrect value. ',
                        excelParserError3: ' contains a duplicated talk. If you want to modify the talk, upload it only once with the updated fields. If you want to delete it, do not include it in the Excel.',
                        eventFinished1: 'This event has finished. At ProxyHands, we take our customers feedback very seriously.',
                        eventFinished2: 'Tell us about your experience at clients@proxyhands.com.',
                        captionTable: 'This table represents the current talks of the event, and the values read from the uploaded Excel.',
                        tableNameHeader: 'Name',
                        tableLocationHeader: 'Location',
                        tableCodeHeader: 'Code',
                        tableInitDateHeader: 'Init time',
                        tableFinishDateHeader: 'Finish time',
                        updateTalks: 'For any changes, simply re-upload the Excel with the updated information. We will delete all previous talks and create new ones from the Excel.',
                        uploadTalks: 'Upload talks',
                        noTalks: 'Your event doesn\'t have any talks yet. Follow the steps below to create the talks and allow attendees to ask questions.',
                        step1: 'Step 1: Download the excel talk template in English or Spanish.',
                        esTemplate: 'Download spanish template',
                        enTemplate: 'Download english template',
                        step2: 'Step 2: Replace the example talks in the template with those from your event. Pay attention to the date format.',
                        step3: 'Step 3: Click on the button below and select the Excel file (only .xlsx format is accepted) with the actual talks from your event. If everything is correct, we will display all your talks on the next screen.',
                        exit: 'Logout'
                    }
                }
            },
            es: {
                translation: {
                    general: {
                      yes: 'Sí',
                      no: 'No'
                    },
                    main: {
                        partnerAccess: 'Acceso Partners'
                    },
                    error: {
                        message1: 'Parece que tenemos un problema. Vuelve a intentarlo en unos segundos.',
                        message2: 'Si sigue sin funcionar escríbenos a',
                        message3: 'y lo arreglaremos lo antes posible.'
                    },
                    partner: {
                        onlyExcelAllowed: 'Solo se admiten ficheros Excel en formato .xlsx',
                        eventFinishedError: 'Hola, parece que el evento ha terminado. Si no es así, escribe a support@proxyhands.com y te ayudaremos.',
                        genericError: 'Hola, tenemos alguna dificultad técnica. Vuelve a intentarlo en unos segundos. Si sigue sin funcionar escríbenos a support@proxyhands.com contándonos el problema.',
                        excelDateParserError: 'Las fechas son obligatorias y deben tener el formato dd/MM/yyyy (24/05/2021 por ejemplo). Se usa la / como separador, y los primeros meses del año llevan 0. El año debe tener 4 dígitos.',
                        excelTimeParserError: 'Las horas son obligatorias y deben tener el formato HH:MM (21:30 por ejemplo). Se separan con : y no contienen segundos.',
                        excelLocationParserError: 'La columna de ubicación está dando problemas. Trata de introducir el valor sin símbolos raros (sólo texto y números). Si no funciona prueba a subir el excel sin esa columna, ya que es opcional.',
                        excelParserError1: 'La fila ',
                        excelParserError2: ' del excel tiene un valor incorrecto. ',
                        excelParserError3: ' del excel tiene una charla duplicada. Si quieres modificar la charla súbela solo una vez con los campos actualizados. Si quieres borrarla, no la incluyas en el excel.',
                        eventFinished1: 'Este evento ha terminado. En ProxyHands nos tomamos muy en serio el feedback de nuestros clientes.',
                        eventFinished2: 'Cuéntanos tu experiencia en clients@proxyhands.com',
                        captionTable: 'Esta tabla representa las charlas actuales del evento, y los valores leídos del excel que se ha subido.',
                        tableNameHeader: 'Nombre',
                        tableLocationHeader: 'Localización',
                        tableCodeHeader: 'Código',
                        tableInitDateHeader: 'Hora de inicio',
                        tableFinishDateHeader: 'Hora de finalización',
                        updateTalks: 'Para cualquier cambio simplemente vuelve a subir el excel con la información actualizada. Borraremos todas las charlas antiguas y crearemos todas las del excel.',
                        uploadTalks: 'Subir charlas',
                        noTalks: 'Tu evento todavía no tiene charlas. Sigue los siguientes pasos para crear las charlas y que los asistentes hagan preguntas.',
                        step1: 'Paso 1: Descárgate la plantilla excel de charlas en inglés o en español',
                        esTemplate: 'Descargar plantilla en español',
                        enTemplate: 'Descargar plantilla en inglés',
                        step2: 'Paso 2: Sustituye las charlas de ejemplo de la plantilla por las de tu evento. Pon atención al formato de fecha.',
                        step3: 'Paso 3: Haz click en el botón de abajo y selecciona el excel (solo se admite formato .xlsx) con las charlas reales de tu evento. Si todo es correcto te mostraremos todas tus charlas en la siguiente pantalla.',
                        exit: 'Salir'
                    },
                }
            }
        }
    });

export default i18n;